import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getClientCredentials } from '../redux/actions/clients';
import { StoreState } from '../types/state';

const useClientCredentials = (id) => {
  const { credentials, hasValue } = useSelector((state: StoreState) => {
    return {
      credentials: state.clients.clientCredentials[id],
      hasValue: Object.keys(state.clients.clientCredentials).includes(id),
    };
  });
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!hasValue && !credentials) {
      setIsLoading(true);
      dispatch(getClientCredentials(id));
    } else setIsLoading(false);
  }, [credentials, id, hasValue, dispatch]);

  return { credentials, isLoading };
};

export default useClientCredentials;
